<div class="auth-form">
  <div class="mt-150">
    <span class="title title--big">Некорректная ссылка</span>
  </div>
  <div class="mt-32">
    <div class="color-blue-dark">Ссылка, по которой вы перешли, устарела, либо была использована повторно.</div>
    <div class="mt-32">
      <a routerLink="{{ '/' + AUTH_PATHS.recovery_access }}" class="link link--blue-dark" id="appReturnToRecoveryAccess"> Вернуться к восстановлению пароля </a>
    </div>
  </div>
</div>
